import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/responsive.css";
import { supabase } from "./lib/supabase";
import { installGlobalErrorReporter } from "./lib/errorReporter";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Uncaught errors + unhandled rejections → error_log → GCP Error Reporting
// (deduped, session-capped, URL-scrubbed — see lib/errorReporter.js).
installGlobalErrorReporter();

// This app intentionally ships NO service worker (an online-only EMR must always
// run the freshest bundle). Proactively unregister any legacy worker and purge its
// caches so a previously-installed cache-first SW can't serve stale code. The
// self-destruct public/sw.js cleans up clients still controlled by the old worker.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((rs) => rs.forEach((r) => r.unregister()))
    .catch(() => {});
  if (window.caches?.keys) {
    caches.keys().then((ks) => ks.forEach((k) => caches.delete(k))).catch(() => {});
  }
}
